import React from "react";
import { useLocation } from "react-router";
import defaultIcon from "./default.svg";
import selectedIcon from "./selected.svg";

function CostProfilesIcon({ className }: { className: string }) {
  const { pathname } = useLocation();

  return (
    <img
      src={/\/cost-profiles/.test(pathname) ? selectedIcon : defaultIcon}
      className={className}
    />
  );
}

export { CostProfilesIcon };
